import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/global.css' // 引入全局样式文件g
import locale from 'element-ui/lib/locale/lang/en'
import {
  message
} from '@/api/resetMessage';
import pageTitle from "@/components/page-title.vue";
import raSearchBox from "@/components/ra-search-box.vue";
import raPagination from "@/components/ra-pagination.vue";
import tableEmpty from "@/components/table-empty.vue";
import raRender from "@/components/ra-render.vue";

Vue.component('page-title', pageTitle);
Vue.component('ra-search-box', raSearchBox);
Vue.component('ra-pagination', raPagination);
Vue.component('table-empty', tableEmpty);
Vue.component('ra-render', raRender);

Vue.config.productionTip = false
Vue.use(ElementUI, { locale });
Vue.prototype.$message = message;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
